import React, { Suspense, Fragment, lazy } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Scene404 from '../scenes/Scene404';
import Desktop404 from '../scenes/Desktop404';
import News from '../scenes/News';
import NewsMobile from '../layouts/sections/OldDesktopSidebar/News';
import HowToPlay from '../scenes/HowToPlay';
import { ProductDetails } from '../scenes/HowToPlay';
import Article from '../scenes/Article';
import { Paths } from 'configs/user-area';
import { PRODUCT_IDS } from 'configs/products';
import { isMobile } from 'react-device-detect';
import VideoReplays from '../scenes/VideoReplays';
import ReplaysResult from '../scenes/ReplaysResult';
import { byPlatform } from 'utils/platforms';
import { EVENT_PATH } from 'utils/navigation';
import { withRouter } from 'react-router';
import DepositError from 'features/Deposit/Error';
import DepositSuccess from 'features/Deposit/Success';
import Home from '../scenes/Home';
import BrandBook from '../scenes/BrandBook';
import BetBuddy from 'features/BetBuddy/Mobile/EntryPage';
import GroupInfoScreen from '../features/BetBuddy/Mobile/GroupInfoScreen';
import DerbyLyn from '../scenes/DerbyLyn';
import Experts from '../scenes/Experts';
import HowSpilKlubWorks from '../scenes/HowSpilKlubWorks';
import Unsubscribe from '../scenes/Unsubscribe';
import LiveStreamDesktop from '../scenes/LiveStreamDesktop';
import AmountForm from 'features/Deposit/AmountForm';
import DesktopLogin from '../features/Login/DesktopLogin';

const Welcome = lazy(() => import('../scenes/Welcome'));
const History = lazy(() => import('../scenes/History'));
const Results = lazy(() => import('../scenes/Results'));
const Live = lazy(() => import('../scenes/Live'));
const FinalSelectionsScreen = lazy(() =>
    import('../features/BetBuddy/Mobile/FinalSelectionsScreen')
);
const Promo = lazy(() => import('../features/Promo'));
const LiveCasino = lazy(() => import('../scenes/LiveCasino'));
const BatchBettingPage = lazy(() => import('../features/BatchBetting/page'));

//import { getRoutes } from 'utils/navigation';

class DKRouter extends React.Component {
    renderWithSuspense = (Component, routerProps = {}) => (
        <Suspense fallback={<p>Loading...</p>}>
            <Component {...routerProps} />
        </Suspense>
    );

    render() {
        return (
            <Fragment>
                <Switch>
                    <Route
                        exact
                        path="/"
                        // since Home is wrapped with HOC wrapping it into
                        // the function fixes prop types warning
                        // @see https://github.com/ReactTraining/react-router/issues/4354
                        component={Home}
                    />
                    <Route
                        path={`/${
                            EVENT_PATH['DK']
                        }/:date/:product?/:track?/:race?`}
                        component={Home}
                    />
                    <Route path="/hjem" component={Home} />
                    {/* batch betting */}
                    <Route
                        path="/systemspil"
                        component={() =>
                            this.renderWithSuspense(BatchBettingPage)
                        }
                    />
                    <Route
                        path="/mitid-verify/success/:type?"
                        component={Home}
                    />
                    <Route path="/mitid-verify/error" component={Home} />
                    <Route
                        path="/mitid-verify/confirm/:type"
                        component={Home}
                    />
                    <Route
                        path="/promo/:page"
                        component={() => this.renderWithSuspense(Promo)}
                    />
                    <Route
                        path="/promo/velkommen"
                        component={() => this.renderWithSuspense(Promo)}
                    />
                    <Route
                        path="/velkommen"
                        component={() => this.renderWithSuspense(Welcome)}
                    />
                    <Route
                        path="/gruppe-oversigt"
                        component={GroupInfoScreen}
                    />
                    {/* User Area Routes */}
                    {/*
                         Every user area route should be specified here
                         to avoid re-rendering of AISDataProvider which is
                         a part of Home page.
                        */}
                    <Route path="/konto" component={Home} />
                    <Route path="/konto/indbetaling" component={Home} />
                    <Route path="/opret-konto" component={Home} />
                    {/* Fallback route for older links */}
                    <Route path="/opret" component={Home} />
                    <Route path="/konto/withdraw" component={Home} />
                    <Route path="/konto/voucher" component={Home} />
                    <Route path="/konto/activebets" component={Home} />
                    <Route path="/konto/finishedbets" component={Home} />
                    <Route path="/konto/profile" component={Home} />
                    <Route path="/konto/transactions" component={Home} />
                    <Route path="/konto/selfexclusion" component={Home} />
                    <Route path="/konto/depositlimits" component={Home} />
                    <Route path="/konto/newsletter" component={Home} />
                    <Route path="/log-ind" component={Home} />
                    {/*<Route path="/log-ind" children={<DesktopLogin />} />*/}
                    <Route path="/testing/log-ind" component={Home} />
                    {/* Fallback route for older links */}
                    <Route path="/login" component={Home} />
                    {/* Other modals */}
                    <Route path="/deposit/error" component={DepositError} />
                    <Route path="/deposit/success" component={DepositSuccess} />
                    {Object.values(Paths).map((path, index) => (
                        <Route
                            key={index}
                            path={'/' + path.url}
                            component={Home}
                        />
                    ))}
                    {Object.values(PRODUCT_IDS).map((id, index) => (
                        <Route key={index} path={'/' + id} component={Home} />
                    ))}
                    <Route
                        path="/mine-spil"
                        component={() => this.renderWithSuspense(History)}
                    />
                    <Route path="/derby-lyn" component={DerbyLyn} />
                    <Route
                        path="/live"
                        component={() => this.renderWithSuspense(Live)}
                    />
                    <Route
                        path="/live-casino"
                        exact
                        component={(props) =>
                            this.renderWithSuspense(LiveCasino, props)
                        }
                    >
                        <Redirect to={`/live-casino/alle`} />
                    </Route>
                    <Route
                        path="/live-casino/:category"
                        component={(props) =>
                            this.renderWithSuspense(LiveCasino, props)
                        }
                    />
                    <Route path="/live-stream" component={LiveStreamDesktop} />
                    <Route path="/deposit-test" component={AmountForm} />
                    <Route
                        path="/nyheder/:link"
                        component={byPlatform(NewsMobile, Article)}
                    />
                    <Route
                        path="/25-nyt/:link"
                        component={byPlatform(NewsMobile, Article)}
                    />
                    <Route
                        path="/nyheder"
                        component={byPlatform(NewsMobile, News)}
                    />
                    <Route
                        path="/25-nyt"
                        component={byPlatform(NewsMobile, News)}
                    />
                    <Route
                        path="/spk/:link"
                        component={byPlatform(
                            () => (
                                <BetBuddy
                                    sharedLink={true}
                                    fromRoute={true}
                                    onBurgerMenuClick={
                                        this.props.onBurgerMenuClick
                                    }
                                />
                            ),
                            Home
                        )}
                    />
                    <Route
                        path="/spil-klub25/pool/:poolId/edit-selections"
                        component={() =>
                            this.renderWithSuspense(FinalSelectionsScreen)
                        }
                    />
                    <Route
                        path="/spil-klub25"
                        component={byPlatform(
                            () => (
                                <BetBuddy
                                    onBurgerMenuClick={
                                        this.props.onBurgerMenuClick
                                    }
                                />
                            ),
                            Home
                        )}
                    />
                    <Route path="/brandbook" component={BrandBook} />
                    <Route
                        path="/sadan-spiller-du/:productId"
                        component={ProductDetails}
                    />{' '}
                    <Route
                        path="/spilklub25-køb-andele-til-eksperternes"
                        component={Experts}
                    />
                    <Route
                        path="/sådan-fungerer-spilklub25"
                        component={HowSpilKlubWorks}
                    />
                    <Route path="/afmeld-nyhedsbrev" component={Unsubscribe} />
                    <Route path="/sadan-spiller-du" component={HowToPlay} />
                    {
                        <Route
                            path="/resultat"
                            component={() => this.renderWithSuspense(Results)}
                        />
                    }
                    <Route
                        path="/replays"
                        component={byPlatform(
                            VideoReplays,
                            ReplaysResult,
                            ReplaysResult
                        )}
                    />
                    {/* Routes from the config file */}
                    {/*{getRoutes().map(({ path, component, current, id }) => (*/}
                    {/*<Route*/}
                    {/*key={id}*/}
                    {/*path={path}*/}
                    {/*component={component}*/}
                    {/*current={current}*/}
                    {/*/>*/}
                    {/*))}*/}
                    {/* Fallback route */}
                    <Route component={isMobile ? Scene404 : Desktop404} />
                </Switch>
            </Fragment>
        );
    }
}

export default React.memo(withRouter(DKRouter));
